// --- GSAP等の設定 ----
// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// import { CustomEase } from "gsap/CustomEase.js"; // カスタムイージング作成が必要なときは使用

gsap.registerPlugin(ScrollTrigger);


document.addEventListener('DOMContentLoaded', function (event) {

  const kv = document.querySelector('.js-front-kv-inner');
  const about = document.querySelector('.js-front-about');
  const aboutInner = document.querySelector('.js-front-about-inner');
  if (about) {
    // --- KV copy effect ------
    if (kv) {
      gsap.to(kv, {
        translateY: -1 * Math.floor(window.innerHeight / 2),
        ease: 'power1.out',
        // duration: 1,
        delay: 1,
        scrollTrigger: {
          toggleActions: 'play pause resume reset',
          trigger: about,
          // start: `top bottom-=${-1 * Math.floor(window.innerHeight * 3 / 4)}px`,
          start: `top bottom`,
          end: `top -300%`,
          scrub: true,
          onLeave: function () {
            kv.style.opacity = 0;
          },
          onEnterBack: function () {
            kv.style.opacity = 1;
          }
        }
      });

      // --- about effect ------
      gsap.to(about, {
        borderRadius: 0,
        ease: 'power1.out',
        width: '100%',
        // duration: 1,
        delay: 1,
        scrollTrigger: {
          toggleActions: 'play pause resume reset',
          trigger: about,
          // start: `top bottom-=${-1 * Math.floor(window.innerHeight * 3 / 4)}px`,
          start: `top 90%`,
          end: `top 50%`,
          scrub: true,
        }
      });

      // --- type-effect
      setTypeEffect();


      // --- about-inner show
      if (aboutInner) {

        // disableSt(stArray);

        const position = window.innerWidth < window.innerHeight ? Math.floor(window.innerHeight * 1 / 4) : Math.floor(window.innerHeight * 1 / 4);
        gsap.to(aboutInner, {
          opacity: 1,
          ease: 'power1.out',
          translateY: 0,
          // duration: 1,
          // delay: 1,
          scrollTrigger: {
            toggleActions: 'play pause resume reset',
            trigger: about,
            start: `top center`,
            // end: `top center`,
            // scrub: true,
            onEnter: () => {
              if (aboutInner.querySelector('.js-ttl-effect-about')) {
                setTimeout(function () {
                  aboutInner.querySelector('.js-ttl-effect-about').classList.add('is-show');
                }, 200);
                // setTimeout(function () {
                //   enableSt(stArray)
                // }, 1000);
              }
            },
            onLeaveBack: () => {
              if (aboutInner.querySelector('.js-ttl-effect-about')) {
                aboutInner.querySelector('.js-ttl-effect-about').classList.remove('is-show');
                // disableSt(stArray);
              }
            }
          }
        });
      }

    }
  }
  
  // --- タイプ風エフェクト ----  
  function setTypeEffect() {
    // スクロールトリガー配列
    // const stArray = [];
    
    if (document.querySelector('.js-type .js-type-line')) {
      // 準備（1文字ずつspanで括る
      document.querySelectorAll('.js-type .js-type-line').forEach(line => {
        const charArray = line.innerText.split('');
        if (charArray.length > 0) {
          let html = '';
          let idx = 0;
          for (let char of charArray) {
            // const num = String(idx).padStart(3, '0');
            if (/^[ァ-ヴー・]$/.test(char)) {
              html += `<span class="ls_0 c-type__line__char js-type-char" data-type-index="${idx}">${char}</span>`
            } else {
              html += `<span class="c-type__line__char js-type-char" data-type-index="${idx}">${char}</span>`
            }
            idx += 1;
          }
          line.innerHTML = html;
          line.classList.remove('--pre-set');
        } else {
          line.classList.remove('--pre-set');
        }

      });

      // const isPortrate = window.innerWidth < window.innerHeight;
      const BASE_START_POSITION = 85;
      const BASE_END_POSITION = 83;


      document.querySelectorAll('.js-type').forEach(wrapper => {
        let type = 0;
        if (wrapper.classList.contains('--body')) {
          type = 1;
        }
        wrapper.querySelectorAll('.js-type-line').forEach((line, i) => {
          // const a = i === 0 ? -1 : 0;
          // const baseStart = BASE_START_POSITION - 5 * a;
          // const baseEnd = BASE_END_POSITION - 5 * a;
          let baseStart, baseEnd;
          if (type === 1) {
            baseStart = BASE_START_POSITION - 4 * i;
            baseEnd = BASE_END_POSITION - 4 * i;
          } else {
            baseStart = BASE_START_POSITION;
            baseEnd = BASE_END_POSITION;
          }
          line.querySelectorAll('.js-type-char').forEach((char, charIdx) => {

            let posStart, posEnd;
            if (type === 1) {
              posStart = baseStart - 0.3 * charIdx;
              posEnd = baseEnd - 0.3 * charIdx;
            } else {
              posStart = baseStart - 0.7 * charIdx;
              posEnd = baseEnd - 0.7 * charIdx;
            }


            const animation = gsap.to(char, {
              opacity: 1,
              ease: 'power1.out',
              // duration: 1,
              // delay: 1,
              scrollTrigger: {
                toggleActions: 'play pause resume reset',
                trigger: char,
                start: `top ${posStart}%`,
                end: `top ${posEnd}%`,
                scrub: true,
              }
            });

            // stArray.push(animation.scrollTrigger);

          });
        })
      })
    }

    // return stArray;

  }
  function disableSt(stArray) {
    for (let st of stArray) {
      st.disable();
    }
  }
  function enableSt(stArray) {
    for (let st of stArray) {
      st.enable();
    }
  }
// });

// window.addEventListener('load', function() {
  // --- スクロールエフェクトを設定する処理 -------
  function setScrollEffect() {

    // --- scrollEffect ---
    if (document.querySelector('.js-slideup')) {
      document.querySelectorAll('.js-slideup').forEach(elm => {

        ScrollTrigger.create({
          toggleActions: 'play pause resume reset',
          trigger: elm,
          start: `top bottom`,
          onEnter: function() {
            elm.classList.remove('init');
          },
          onLeaveBack: function() {
            elm.classList.add('init');
          },
          // scrub: true,
        })

        // gsap.to(elm, {
        //   opacity: 1,
        //   // ease: 'power1.out',
        //   translateY: 0,
        //   // duration: 1,
        //   // delay: 1,
        //   scrollTrigger: {
        //     toggleActions: 'play pause resume reset',
        //     trigger: elm,
        //     start: `top bottom`,
        //     // end: `top bottom`,
        //     // scrub: true,
        //   }
        // });
      });
    }
    if (document.querySelector('.js-ttl-effect')) {
      document.querySelectorAll('.js-ttl-effect').forEach(elm => {

        ScrollTrigger.create({
          toggleActions: 'play pause resume reset',
          trigger: elm,
          start: `top bottom`,
          // end: `top bottom`,
          // scrub: true,
          onEnter: () => {
            elm.classList.add('is-show');
            setTimeout(function () {
              elm.classList.add('is-moving');
            }, 1000);
          },
          onLeaveBack: () => {
            elm.classList.remove('is-moving');
            elm.classList.remove('is-show');
          }
        });
        // gsap.to(elm, {
        //   ease: 'power1.out',
        //   scrollTrigger: {
        //     toggleActions: 'play pause resume reset',
        //     trigger: elm,
        //     start: `top bottom`,
        //     end: `top bottom`,
        //     scrub: true,
        //     onLeave: () => {
        //       elm.classList.add('is-show');
        //       setTimeout(function () {
        //         elm.classList.add('is-moving');
        //       }, 1000);
        //     },
        //     onLeaveBack: () => {
        //       elm.classList.remove('is-moving');
        //       elm.classList.remove('is-show');
        //     }
        //   }
        // });
      });
    }
  }
  
  if (!document.querySelector('.p-front')) {
    setScrollEffect();
  }

  // ページタイトル（scrollTrigger不使用だが、js-ttl-effectと同エフェクトのためここに記載）
  if (document.querySelector('.js-page-title')) {
    document.querySelectorAll('.js-page-title').forEach(elm => {
      elm.classList.add('is-show');
      setTimeout(function () {
        elm.classList.add('is-moving');
      }, 1000);
    });
  }


  // --- 沿革 ----
  if (document.querySelector('.js-history')) {

    document.querySelectorAll('.js-history').forEach(elm => {

      gsap.to(elm, {
        // opacity: 1,
        // ease: 'power1.out',
        // duration: 1,
        // delay: 1,
        scrollTrigger: {
          // toggleActions: 'play pause resume reset',
          trigger: elm,
          start: `top center`,
          // end: `top ${posEnd}%`,
          scrub: true,
          onEnter: function () {
            elm.classList.add('is-show');
          }
        }
      });
    })



  }

  // --- パーティクルズ背景の固定 -----
  if (document.querySelector('.js-bg-particles-area .js-bg-particles')) {
    document.querySelectorAll('.js-bg-particles-area .js-bg-particles').forEach(elm => {
      const wrapper = elm.closest('.js-bg-particles-area');
      // console.log(wrapper);
      gsap.to(elm, {
        position: 'fixed',
        scrollTrigger: {
          toggleActions: 'play reset resume reset',
          trigger: wrapper,
          start: `top top`,
          end: `bottom top`,
          scrub: true,
          // onEnter: function() {
          //   console.log('enter');
          // },
          // onLeave: function () {
          //   elm.style.position = '';
          // }
        }
      })
    })
  }

// });

// window.addEventListener('load', function (event) {

  // --- スクロール駆動スライダー（TOP > Product） ------
  if (document.querySelector('.js-front-product-section-outer .js-front-product-section-inner .js-front-product-wrapper .js-front-product .js-front-product-inner')) {

    // 初期設定
    // let ww, wh;
    const sectionOuter = document.querySelector('.js-front-product-section-outer');
    const sectionInnter = sectionOuter.querySelector('.js-front-product-section-inner');
    const wrapper = sectionInnter.querySelector('.js-front-product-wrapper');
    const slider = wrapper.querySelector('.js-front-product');
    const inner = slider.querySelector('.js-front-product-inner');

    const sliderInnerWidth = inner.scrollWidth;
    const ww = window.innerWidth;
    const showArea = ww > 1295 ? (ww - 1166) / 2 + 1166 : ww * 0.95;
    console.log(`sliderInnerWidth: ${sliderInnerWidth}, showArea: ${showArea}`);

    // スクロール設定判定
    if (sliderInnerWidth > showArea) {
      // console.log('in');

      // 横スクロール長
      const sliderWidth = slider.clientWidth;
      const translateLength = Math.floor(sliderInnerWidth - sliderWidth);
      
      // 
      const originSectionHeight = sectionInnter.clientHeight;
      
      const wh = window.innerHeight;
      const sliderHeight = slider.clientHeight;
      const diffSectionToSlider = slider.getBoundingClientRect().top - sectionInnter.getBoundingClientRect().top;
      const stickyTop = Math.floor(diffSectionToSlider - (wh - sliderHeight) / 2);

      // const stickyTop = Math.floor(wh - originSectionHeight);

      // セクションの高さを足して、sectionInnerを固定（sticky）
      sectionOuter.style.height = `${Math.floor(originSectionHeight + Math.abs(translateLength))}px`;
      sectionInnter.style.position = 'sticky';
      sectionInnter.style.top = `${-1 * stickyTop}px`;

      if (sectionOuter.classList.contains('js-fixed-switch')) {
        setSwitchFixed(sectionOuter);
      }
      console.log(stickyTop)
      console.log(stickyTop - Math.abs(translateLength))

      // 横スクロール
      gsap.to(inner, {
        translateX: `${-1 * Math.abs(translateLength)}px`,
        ease: 'power1.in',
        scrollTrigger: {
          toggleActions: 'play pause resume reset',
          trigger: sectionOuter,
          // start: `top${stickyTop < 0 ? `-=${-1 * stickyTop}` : `+=${stickyTop}`}px top`,
          start: `top+=${stickyTop}px top`,
          end: `top+=${stickyTop + Math.abs(translateLength)}px top`,
          scrub: true,
          // markers: true,
        }

      });
      
      // スクロールエフェクト設定
      setScrollEffect();

    } else {
      // Recruitが被さるエフェクト
      if (document.querySelector('.js-front-product-section-outer.js-fixed-switch')) {
        setSwitchFixed(document.querySelector('.js-front-product-section-outer.js-fixed-switch'));
      }

      // スクロールエフェクト設定
      setScrollEffect();
    }




  } 
  // else {
  //   // TOP以外
  //   setScrollEffect();
  // }

  // --- セクションがかぶさるエフェクト（TOP > 採用情報） ----
  // if (document.querySelector('.js-overlay-wrapper .js-overlay')) {
  //   document.querySelectorAll('.js-overlay-wrapper .js-overlay').forEach(elm => {
  //     const wrapper = elm.closest('.js-overlay-wrapper');
  //     let clientHeight, device, setScrollTrigger = false;
  //     init();

  //     window.addEventListener('resize', init);

  //     function init() {
  //       device = window.innerWidth > 768 ? 'pc' : 'sp';
  //       clientHeight = Math.ceil(elm.clientHeight);
  //       wrapper.style.height = device === 'pc' ? `${Math.floor(clientHeight / 3)}px` : `${Math.floor(clientHeight / 2)}px`;
  //       elm.style.height = clientHeight;
  //       elm.style.position = 'absolute';
  //       if (setScrollTrigger) {
  //         ScrollTrigger.getById('frontRecruit').kill();
  //       }
  //       gsap.to(elm, {
  //         translateY: device === 'pc' ? -1 * Math.floor(clientHeight * 2 / 3) : -1 * Math.floor(clientHeight / 2),
  //         ease: 'power1.in',
  //         scrollTrigger: {
  //           toggleActions: 'play pause resume reset',
  //           trigger: wrapper,
  //           start: `top bottom`,
  //           // end: `top bottom-=${device === 'pc' ? '30%' : '50%'}`,
  //           end: `top bottom-=50%`,
  //           scrub: true,
  //           id: 'frontRecruit'
  //         }

  //       });
  //       setScrollTrigger = true;
  //     }


  //   })
  // }
  // [初期値] => Fixed
  // function prepareSwitchFixed(target) {
  //   const wrapper = target.closest('.js-fixed-switch-wrapper');
          
  //   if (!wrapper) {
  //     throw new Error('Fixedへ切替処理の親要素 .js-fixed-switch-wrapper がありません');
  //   }
  //   wrapper.style.height = Math.floor(wrapper.clientHeight) + 'px';
  // }
  function setSwitchFixed(target) {
    // if (document.querySelector('.js-fixed-switch-wrapper .js-fixed-switch')) {
    //   document.querySelectorAll('.js-fixed-switch-wrapper .js-fixed-switch').forEach(target => {
    //     try {
          const wrapper = target.closest('.js-fixed-switch-wrapper');
          
          if (!wrapper) {
            throw new Error('Fixedへ切替処理の親要素 .js-fixed-switch-wrapper がありません');
          }
          
          target.style.position = '';
          wrapper.style.height = Math.floor(wrapper.clientHeight) + 'px';
          ScrollTrigger.create({
            trigger: wrapper,
            start: `bottom bottom`,
            // scrub: true,
            onEnter: function() {
              target.style.position = 'fixed';
            },
            onLeaveBack: function() {
              target.style.position = '';
              // target.classList.remove('--fixed');
            },
          })
          
          // gsap.to(target, {
          //   scrollTrigger: {
          //     trigger: wrapper,
          //     start: `bottom bottom`,
          //     scrub: true,
          //     onEnter: function() {
          //       target.classList.add('--fixed');
          //     },
          //     onLeaveBack: function() {
          //       target.classList.remove('--fixed');
          //     },
          //   }
          // });
          // const st = ScrollTrigger.create({
          //   trigger: wrapper,
          //   start: `bottom bottom`,
          //   // scrub: true,
          //   onEnter: function() {
          //     target.style.position = 'fixed';
          //   },
          //   onLeaveBack: function() {
          //     target.style.position = '';
          //     // target.classList.remove('--fixed');
          //   },
          // })

          // function setHeight() {
          //   if (st) {
          //     st.disable();
          //   }
            
          //   target.style.position = '';
          //   wrapper.style.height = Math.floor(wrapper.clientHeight) + 'px';
          //   if (st) {
          //     st.enable();
          //   }
          // }
          // setHeight();

          // window.addEventListener('resize', setHeight)

        // } catch(err) {
        //   console.error(err);
        // }
      // })
    // }
  }
  


  // --- モックエフェクト（私たちについて > MISSION、VISION、VALUE）------
  if (document.querySelector('.js-mock-init-wrapper .js-mock-init')) {
    // 初期設定
    const wrapper = document.querySelector('.js-mock-init-wrapper');
    const inner = wrapper.querySelector('.js-mock-init');
    const headerHeight = document.querySelector('header.l-header') ? document.querySelector('header.l-header').clientHeight : 0;
    const panMarginTop = document.querySelector('.l-breadcrumbs') && !isNaN(Number(window.getComputedStyle(document.querySelector('.l-breadcrumbs')).getPropertyValue('margin-top').split('px')[0])) ? Number(window.getComputedStyle(document.querySelector('.l-breadcrumbs')).getPropertyValue('margin-top').split('px')[0]) : 0;
    const wh = window.innerHeight;
    // const ww = window.innerWidth;
    const ch = Math.floor(inner.clientHeight);

    wrapper.style.height = `${ch + panMarginTop}px`;
    if (ch > wh - headerHeight - panMarginTop) {
      wrapper.style.minHeight = `${ch}px`;
      inner.style.position = 'absolute';
      gsap.to(inner, {
        position: 'fixed',
        // top: 'auto',
        // bottom: 0,
        scrollTrigger: {
          toggleActions: 'play pause resume reset',
          trigger: wrapper,
          start: `bottom bottom`,
        }
      });
    } else {
      inner.style.position = 'fixed';
    }
  }

  if (document.querySelector('.js-mock .js-mock-image')) {
    document.querySelectorAll('.js-mock .js-mock-image').forEach(elm => {
      const wrapper = elm.closest('.js-mock');
      gsap.to(elm, {
        position: 'fixed',
        scrollTrigger: {
          toggleActions: 'play pause resume reset',
          trigger: wrapper,
          start: `top top`,
          end: `bottom top`,
          scrub: true,
        }
      });
      const blur = wrapper.querySelector('.js-mock-blur');
      if (blur) {
        // console.log('in');
        const startPosition = Math.floor(window.innerHeight * 2 / 3);
        gsap.to(blur, {
          opacity: 1,
          scrollTrigger: {
            toggleActions: 'play pause resume reset',
            trigger: wrapper,
            start: `bottom-=${startPosition}px top`,
            end: `bottom top`,
            scrub: true,
          }
        });
      }
    })
  }


  // --- スクロール連動アニメーション (TOP > エンジニアリングサービス事業) ------
  if (document.querySelector('.js-feature-animation')) {
    const triggers = [
      { trigger: '.js-feature-animation-trigger-1st', class: 'is-1st' },
      { trigger: '.js-feature-animation-trigger-2nd', class: 'is-2nd' },
      { trigger: '.js-feature-animation-trigger-3rd', class: 'is-3rd' }
    ];

    const target = document.querySelector('.js-feature-animation-target');

    triggers.forEach(({ trigger, class: className }) => {
      ScrollTrigger.create({
        trigger: trigger,
        start: 'top center',
        onEnter: () => {
          // すべての is-* クラスを削除
          target.classList.remove('is-1st', 'is-2nd', 'is-3rd');
          // 対応するクラスを追加
          target.classList.add(className);
        },
        onEnterBack: () => {
          // スクロールバック時も同様の処理
          target.classList.remove('is-1st', 'is-2nd', 'is-3rd');
          target.classList.add(className);
        }
      });
    });
  }




})

